import Dashboard from './../components/messages/Dashboard.vue'
import Show from './../components/messages/Show.vue'
import Create from './../components/messages/Create.vue'
import Edit from './../components/messages/Edit.vue'
import Root from './../components/Root.vue'
export default {
  path: 'messages',
  component: Root,
  children: [
    {
      path: '',
      name: 'admin.messages.dashboard',
      component: Dashboard
    },
    {
      path: ':id/show',
      name: 'admin.messages.show',
      component: Show
    },
    {
      path: 'create',
      name: 'admin.messages.create',
      component: Create
    },
    {
      path: ':id/update',
      name: 'admin.messages.edit',
      component: Edit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/messages.js